import { useState, useRef } from 'react';
import TokenScoreText from './TokenScoreText.mjs';
import PerkSection from './PerkSection.mjs';
import PerkCartItem from './PerkCartItem.mjs';
import Redemption from './Redemption.mjs';
import { pluralize } from '../utils.mjs';

function PrimeTokensStore({ user, userAccount, preferredLocation, perks, tier, ...props} = props) {
  const { primetokens, wscore, curTier, nextTier } = user;
	const [curTokens, setCurTokens] = useState(primetokens);
	const [curScore, setCurScore] = useState(wscore);
	const [totalCost, setTotalCost] = useState({
		tokens: 0,
		score: 0
	});
  const [perkProps, setPerkProps] = useState(
    perks.map((section) => {
      return section.perks.map((perk) => ({
        id: perk.id,
        selected: false,
        qty: 0,
        costPoints: section.required.wscore ?? 0,
        costTokens: section.required.tokens ?? 0,
        fullName: perk.fullName,
        name: perk.name,
        description: perk.description,
        icon: perk.icon,
      }));
    }).flat()
  );

	//Keep track of the current perk index (since it resets each section)
	let perkIndex = useRef(0);
	const updateIndex = () => {
		perkIndex.current += 1;
	};

	const handleSelect = (id) => {
    const index = perkProps.findIndex((perk) => perk.id === id);
		const newProps = perkProps.slice();
		// Update the quantity to 1 if the perk is selected
		if (perkProps[index].qty == 0) {
			handleQty(id, 'add');
			// Reset Quantity to 0 if the perk is deselected
		} else {
      const costTokens = perkProps[index].costTokens;
      const costPoints = perkProps[index].costPoints;
      setCurTokens(curTokens + costTokens * perkProps[index].qty);
      setCurScore(curScore + costPoints * perkProps[index].qty);
			newProps[index] = { ...newProps[index], qty: 0 };
		}
		newProps[index] = { ...newProps[index], selected: !perkProps[index].selected };
		setPerkProps(newProps);
	};

	const handleQty = (id, action) => {
    const index = perkProps.findIndex((perk) => perk.id === id);
		const newProps = perkProps.slice();
		const costTokens = perkProps[index].costTokens;
		const costPoints = perkProps[index].costPoints;
		switch (action) {
			case 'add':
				newProps[index] = { ...newProps[index], qty: (perkProps[index].qty += 1) };
				setCurTokens(curTokens - costTokens);
				setCurScore(curScore - costPoints);
        setTotalCost({...totalCost, tokens: totalCost.tokens + costTokens, score: totalCost.score + costPoints});
				break;
			case 'subtract':
				newProps[index] = { ...newProps[index], qty: (perkProps[index].qty -= 1) };
				if (newProps[index].qty === 0) {
					newProps[index] = { ...newProps[index], selected: !perkProps[index].selected };
				}
				setCurTokens(curTokens + costTokens);
				setCurScore(curScore + costPoints);
        setTotalCost({...totalCost, tokens: totalCost.tokens - costTokens, score: totalCost.score - costPoints});
				break;
      case 'clear':
        const pointsToClear = newProps[index].qty * newProps[index].costPoints;
        const tokensToClear = newProps[index].qty * newProps[index].costTokens;

        newProps[index] = { ...newProps[index], qty: 0 };
        if (newProps[index].qty === 0) {
          newProps[index] = { ...newProps[index], selected: !perkProps[index].selected };
        }
        setCurTokens(primetokens);
        setCurScore(wscore);
        setTotalCost({...totalCost, tokens: totalCost.tokens - tokensToClear, score: totalCost.score - pointsToClear});
        break;
		}
		setPerkProps(newProps);
	};

  const testForQty = (element, index, array) => {
    return element.qty > 0;
  };

  const emptyCart = () => {
    setPerkProps(perkProps.map((perk) => ({ ...perk, qty: 0, selected: false })));
    setCurTokens(primetokens);
    setCurScore(wscore);
    setTotalCost({ tokens: 0, score: 0 });
  };

  return (
    <div className="prime-token-store">
      <TokenScoreText curTier={curTier} nextTier={nextTier} curScore={curScore} curTokens={curTokens} />

      <div className="row gy-4" data-tier={tier}>
        <div className="col-lg-7 vstack gap-4">
          {perks.map((section, index) => (
            <PerkSection key={index} section={section} onSelect={handleSelect} perkProps={perkProps} curTokens={curTokens} curScore={curScore} onQtyChange={handleQty} perkIndex={perkIndex} updateIndex={updateIndex} />
          ))}
        </div>
        <div className="col-lg-5">
          {
            perkProps.some(testForQty) &&
            <div className="perk-cart p-3 bg-light rounded">
              <div className="vstack gap-4">
                <div className="vstack gap-1">
                  {
                    perkProps.filter(testForQty).map((perk, i) => (
                      <PerkCartItem key={i} perk={perk} handleSelect={handleSelect} handleQty={handleQty} />
                    ))
                  }
                </div>
                <div className="text-center">
                  <button className="btn btn-light mx-auto text-primary" role="button" onClick={emptyCart}>Clear All</button>
                </div>
                <div className="vstack gap-3">
                  <span>You are redeeming {pluralize(totalCost.tokens, 'token')} {
                    totalCost.score > 0 && `and ${totalCost.score.toLocaleString()} WScore.`
                  }</span>
                  <button className="btn btn-primary btn-lg rounded-0 py-4 shadow" role="button" data-bs-target="#redemption-modal" data-bs-toggle="modal">
                    <span className="h4 text-white mb-0">Redeem Now</span>
                  </button>
                </div>
              </div>
            </div>
          }
        </div>
      </div>
      <Redemption userAccount={userAccount} preferredLocation={preferredLocation} totalCost={totalCost} perks={perkProps.filter(testForQty)} />
    </div>
  );
}
export default PrimeTokensStore;
